import React from "react";
import style from "css/solution.module.scss";
import Questions from "components/app/questions";
import SEOMeta from "components/app/SEOMeta";
import Consult from "components/device/neat/consult";
import { useMediaQuery } from "react-responsive";

function CustomPlatform(props) {
  const isMobile = useMediaQuery({ query: "(max-width: 889px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 890px) and (max-width: 1599px)",
  });
  return (
    <>
      <SEOMeta
        title="Custom Platform, 리브테크놀로지"
        description="리브테크놀로지 riv Technology - Custom Platform"
        keywords="리브테크놀로지, 리브테크, 리브, riv, riv Technology, neat, 스마트 회의실, 화상회의, Custom Platform, 텔레헬스 시스템, 비대면 진료, 맞춤형 협진 플랫폼"
      />
      <div className={style.content}>
        <div
          className={`${style.title_area} ${style.custom}`}
          style={{ backgroundColor: "#edf2f8" }}
        >
          <img
            className={style.custom_title_img}
            alt="medilink"
            src={`${process.env.REACT_APP_CLIENT_URL}img/solution/custom/custom_title.png`}
            // style={{ height: 550 }}
          />
          <div className={`${style.title_wrap} ${style.custom}`}>
            <div className={`${style.title} ${style.medilink}`}>
              <span className={style.medilink_title}>
                최적화된 협업 환경,
                <br />
                스마트한 의료 협진.
                <br />
                <bold>맞춤형 협진 플랫폼</bold>
              </span>
              {isMobile ? (
                <div className={style.custom_desc}>
                  병원의 협진 환경을 혁신하는
                  <br />
                  맞춤형 텔레헬스 협진 플랫폼은 Zoom 기능을
                  <br />
                  내재화하여 의료진 간 원활한 협진을 위한
                  <br />
                  최적화된 솔루션을 제공합니다.
                  <br />
                  다양한 의료진이 동시에 참여할 수 있는
                  <br />
                  협진 환경을 조성하며, 실시간 영상 공유와
                  <br />
                  문서 협업을 지원하여 보다 효과적인 의료 협력 환경을
                  <br />
                  제공합니다.
                </div>
              ) : isTablet ? (
                <div className={style.custom_desc}>
                  병원의 협진 환경을 혁신하는 맞춤형 텔레헬스 협진 플랫폼은
                  <br />
                  Zoom 기능을 내재화하여 의료진 간 원활한 협진을 위한
                  <br />
                  최적화된 솔루션을 제공합니다.
                  <br />
                  다양한 의료진이 동시에 참여할 수 있는 협진 환경을 조성하며,
                  <br />
                  실시간 영상 공유와문서 협업을 지원하여 보다 효과적인
                  <br />
                  의료 협력 환경을 제공합니다.
                </div>
              ) : (
                <div className={style.custom_desc}>
                  병원의 협진 환경을 혁신하는 맞춤형 텔레헬스 협진 플랫폼은 Zoom
                  기능을 내재화하여
                  <br />
                  의료진 간 원활한 협진을 위한 최적화된 솔루션을 제공합니다.
                  <br />
                  다양한 의료진이 동시에 참여할 수 있는 협진 환경을 조성하며,
                  <br />
                  실시간 영상 공유와 문서 협업을 지원하여 보다 효과적인 의료
                  협력 환경을 제공합니다.
                </div>
              )}
            </div>
            <div className={style.title_cardlist}>
              <div className={style.title_card}>
                <div className={style.title_logo}>
                  <img
                    className={style.customTitleLogo_1}
                    alt="customTitleLogo1"
                    src={`${process.env.REACT_APP_CLIENT_URL}img/solution/custom/customTitleIcon1${!isMobile && !isTablet ? "" : "_m"}.png`}
                    style={{ height: 18, width: 22 }}
                  />
                </div>
                <span>화상회의 예약 및 이용</span>
              </div>
              <div className={style.title_card}>
                <div className={style.title_logo}>
                  <img
                    className={style.customTitleLogo_2}
                    alt="customTitleLogo2"
                    src={`${process.env.REACT_APP_CLIENT_URL}img/solution/custom/customTitleIcon2${!isMobile && !isTablet ? "" : "_m"}.png`}
                    style={{ height: 22, width: 23 }}
                  />
                </div>
                <span>채팅</span>
              </div>
              <div className={style.title_card}>
                <div className={style.title_logo}>
                  <img
                    className={style.customTitleLogo_3}
                    alt="customTitleLogo3"
                    src={`${process.env.REACT_APP_CLIENT_URL}img/solution/custom/customTitleIcon3${!isMobile && !isTablet ? "" : "_m"}.png`}
                    style={{ height: 22, width: 21 }}
                  />
                </div>
                <span>회의실 예약</span>
              </div>
              <div className={style.title_card}>
                <div className={style.title_logo}>
                  <img
                    className={style.customTitleLogo_4}
                    alt="customTitleLogo4"
                    src={`${process.env.REACT_APP_CLIENT_URL}img/solution/custom/customTitleIcon4${!isMobile && !isTablet ? "" : "_m"}.png`}
                    style={{ height: 19, width: 26 }}
                  />
                </div>
                <span>VoIP 전화</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={`${style.overview_wrap} ${style.custom}`}>
        <div className={style.overview_title}>
          <font>의료진 협업</font>을 실현하는,
          <br />
          <font>병원별 맞춤으로 최적화</font> 솔루션
        </div>
        {
          isMobile ? (
            <div className={style.overview_subtitle}>
              진료 일정, 참여자 구성, 영상회의 환경까지
              <br />
              병원 고유의 협진 방식에 맞춰
              <br />
              커스터마이징되는 협업 플랫폼입니다.
              <br />
              다자간 협진, 문서 공유, 회의실 예약 등 통합 기능으로
              <br />
              보다 유연하고 정확한 의료 의사결정을 지원합니다.
            </div>
          ) : (
            <div className={style.overview_subtitle}>
              진료 일정, 참여자 구성, 영상회의 환경까지 병원 고유의 협진 방식에
              맞춰 커스터마이징되는 협업 플랫폼입니다.
              <br />
              다자간 협진, 문서 공유, 회의실 예약 등 통합 기능으로 보다 유연하고
              정확한 의료 의사결정을 지원합니다.
            </div>
          )
          // :
          // <div className={style.overview_subtitle}>
          //   진료 일정, 참여자 구성, 영상회의 환경까지 병원 고유의 협진 방식에 맞춰 커스터마이징되는 협업 플랫폼입니다.<br />
          //   다자간 협진, 문서 공유, 회의실 예약 등 통합 기능으로 보다 유연하고 정확한 의료 의사결정을 지원합니다.
          // </div>
        }
        <div className={style.overview_contentlist}>
          {/* 1 */}
          <div className={style.overview_content}>
            <div style={{ paddingTop: 150 }}>
              <div>1</div>
              <div>
                <font>간편한 협진</font> 미팅 생성 및 일정 관리
              </div>
              {!isMobile && !isTablet ? (
                <div>
                  의료진은 일정관리 기능을 통해 협진 및 회진 일정을 사전에
                  등록하고,
                  <br />
                  자동 알림을 설정하여 의료진 간의 협업을 보다 효율적으로 운영할
                  수 있습니다.
                </div>
              ) : (
                <div>
                  의료진은 일정관리 기능을 통해 협진 및 회진 일정을 사전에
                  등록하고, 자동 알림을 설정하여 의료진 간의 협업을 보다
                  효율적으로 운영할 수 있습니다.
                </div>
              )}
            </div>
            <img
              alt="custom_content_1"
              src={`${process.env.REACT_APP_CLIENT_URL}img/solution/custom/customContent1${!isMobile && !isTablet ? "" : "_m"}.png`}
            />
          </div>
          {/* 2 */}
          <div className={`${style.overview_content} ${style.reverse}`}>
            <img
              alt="custom_content_2"
              src={`${process.env.REACT_APP_CLIENT_URL}img/solution/custom/customContent2${!isMobile && !isTablet ? "" : "_m"}.png`}
            />
            <div style={{ paddingTop: 159 }}>
              <div>2</div>
              <div>
                <font>진료 데이터</font> 실시간 공유
              </div>
              {!isMobile && !isTablet ? (
                <div>
                  환자의 의료 영상 및 전자차트와 연동하여 협진 중 실시간 데이터
                  <br />
                  공유가 가능 합니다. 화상회의와 자료공유를 통해 영상과 데이터를
                  <br />
                  확인하며, 공동검토가 가능하므로 보다 정확한 진단과 협진이 가능
                  <br />
                  합니다.
                </div>
              ) : (
                <div>
                  환자의 의료 영상 및 전자차트와 연동하여 협진 중 실시간 데이터
                  공유가 가능 합니다.
                  <br />
                  화상회의와 자료공유를 통해 영상과 데이터를 확인하며,
                  공동검토가 가능하므로 보다 정확한 진단과 협진이 가능 합니다.
                </div>
              )}
            </div>
          </div>
          {/* 3 */}
          <div className={style.overview_content}>
            <div style={{ paddingTop: 190 }}>
              <div>3</div>
              <div>
                회의실 예약 및 <font>공간관리 최적화</font>
              </div>
              {!isMobile && !isTablet ? (
                <div>
                  회의실의 이용 현황을 실시간으로 확인하고, 예약 시스템과
                  연동하여
                  <br />
                  공간을 보다 효율적으로 운영할 수 있습니다.
                </div>
              ) : (
                <div>
                  회의실의 이용 현황을 실시간으로 확인하고, 예약 시스템과
                  연동하여 공간을 보다 효율적으로 운영할 수 있습니다.
                </div>
              )}
            </div>
            <img
              alt="custom_content_3"
              src={`${process.env.REACT_APP_CLIENT_URL}img/solution/custom/customContent3${!isMobile && !isTablet ? "" : "_m"}.png`}
            />
          </div>
          {/* 4 */}
          <div className={`${style.overview_content} ${style.reverse}`}>
            <img
              alt="custom_content_4"
              src={`${process.env.REACT_APP_CLIENT_URL}img/solution/custom/customContent4${!isMobile && !isTablet ? "" : "_m"}.png`}
            />
            <div style={{ paddingTop: 134 }}>
              <div>4</div>
              <div>
                <font>Neat</font> 스마트 화상회의 장비 연동
              </div>
              {!isMobile && !isTablet ? (
                <div>
                  Neat 스마트 화상회의 장비와 연동하여 고해상도 화질과 몰입감
                  <br />
                  있는 오디오 환경을 제공합니다. 의료진은 개인 집무실에서 또는
                  <br />
                  협진 회의실에서 직접 대면하는 것과같은 환경을 구축하여 더욱
                  <br />
                  원활하게 진행할 수 있습니다.
                </div>
              ) : (
                <div>
                  Neat 스마트 화상회의 장비와 연동하여 고해상도 화질과 몰입감
                  있는 오디오 환경을 제공합니다.
                  <br />
                  의료진은 개인 집무실에서 또는 협진 회의실에서 직접 대면하는
                  것과같은 환경을 구축하여 더욱 원활하게 진행할 수 있습니다.
                </div>
              )}
            </div>
          </div>
          {/* 5 */}
          <div className={style.overview_content}>
            <div style={{ paddingTop: 128 }}>
              <div>5</div>
              {!isMobile && !isTablet ? (
                <div>
                  병원 환경에 최적화된 <font>보안</font> 및{" "}
                  <font>커스터마이징</font> 지원
                </div>
              ) : (
                <div>
                  병원 환경에 최적화된
                  <br />
                  <font>보안</font> 및 <font>커스터마이징</font> 지원
                </div>
              )}
              {!isMobile && !isTablet ? (
                <div>
                  MediLink는 Zoom 기반의 고급 보안 프로토콜을 적용하여,
                  <br />
                  협진 중 발생하는 모든 영상 및 데이터 흐름을 안전하게
                  보호합니다.
                  <br />
                  또한, 각 의료기관의 환경과 운영 방식에 맞춰{" "}
                  <bold>화면 디자인(UI)부터</bold>
                  <br />
                  <bold>기능 구성까지 맞춤형으로 커스터마이징</bold>이 가능해,
                  <br />
                  병원 고유의 협진 체계를 효율적으로 구현할 수 있습니다.
                </div>
              ) : (
                <div>
                  MediLink는 Zoom 기반의 고급 보안 프로토콜을 적용하여, 협진 중
                  발생하는 모든 영상 및 데이터 흐름을 안전하게 보호합니다.
                  <br />
                  또한, 각 의료기관의 환경과 운영 방식에 맞춰{" "}
                  <bold>화면 디자인(UI)부터</bold>
                  <bold>기능 구성까지 맞춤형으로 커스터마이징</bold>이 가능해,
                  병원 고유의 협진 체계를 효율적으로 구현할 수 있습니다.
                </div>
              )}
            </div>
            <img
              alt="custom_content_5"
              src={`${process.env.REACT_APP_CLIENT_URL}img/solution/custom/customContent5${!isMobile && !isTablet ? "" : "_m"}.png`}
            />
          </div>
        </div>
      </div>

      <div className={style.ability_wrap}>
        {!isMobile && !isTablet ? (
          <div className={style.ability_title}>
            병원의 협진을 더 빠르고, 효과적으로!
          </div>
        ) : (
          <div className={style.ability_title}>
            병원의 협진을 더 빠르고,
            <br />
            효과적으로!
          </div>
        )}
        {isMobile ? (
          <div className={style.ability_subtitle}>
            이제 병원의 협진이 더 안전하고, 신속하게 이루어
            <br />
            질 수 있도록, 맞춤형 텔레헬스 협진 플랫폼을 도입하여
            <br />
            스마트한 협진 환경을 구축해보세요.
          </div>
        ) : (
          <div className={style.ability_subtitle}>
            이제 병원의 협진이 더 안전하고, 신속하게 이루어질 수 있도록,
            <br />
            맞춤형 텔레헬스 협진 플랫폼을 도입하여 스마트한 협진 환경을
            구축해보세요.
          </div>
        )}
        <div className={style.ability_contentlist}>
          {/* 1 */}
          <div className={style.ability_content}>
            <div className={style.ability_header}>
              <div className={style.ability_content_title}>
                <div className={style.title_en}>Integration</div>
                <div className={style.title_kr}>통합성</div>
              </div>
              <div className={style.ability_outer_logo}>
                <div className={style.ability_inner_logo}>
                  <img
                    className={style.ability_logo_1}
                    alt="custom_ability_1"
                    src={`${process.env.REACT_APP_CLIENT_URL}img/solution/custom/customAbilityIcon1${!isMobile && !isTablet ? "" : "_m"}.png`}
                  />
                </div>
              </div>
            </div>
            {!isMobile && !isTablet ? (
              <div className={style.ability_txt}>
                영상회의 · 전화 · 채팅 · 회의실 예약 등의 기능을 하나의
                플랫폼에서
                <br />
                제공하여 의료진이 여러 시스템을 사용할 필요 없이 협진을 진행할
                수<br />
                있습니다.
              </div>
            ) : (
              <div className={style.ability_txt}>
                영상회의 · 전화 · 채팅 · 회의실 예약 등의 기능을 하나의
                플랫폼에서 제공하여 의료진이 여러 시스템을 사용할 필요 없이
                협진을 진행할 수 있습니다.
              </div>
            )}
          </div>
          {/* 2 */}
          <div className={style.ability_content}>
            <div className={style.ability_header}>
              <div className={style.ability_content_title}>
                <div className={style.title_en}>Flexibility</div>
                <div className={style.title_kr}>유연성</div>
              </div>
              <div className={style.ability_outer_logo}>
                <div className={style.ability_inner_logo}>
                  <img
                    className={style.ability_logo_2}
                    alt="custom_ability_2"
                    src={`${process.env.REACT_APP_CLIENT_URL}img/solution/custom/customAbilityIcon2${!isMobile && !isTablet ? "" : "_m"}.png`}
                  />
                </div>
              </div>
            </div>
            {!isMobile && !isTablet ? (
              <div className={style.ability_txt}>
                병원의 기존 시스템 및 다양한 IT 인프라와 연동이 가능하며, 협진
                <br />
                방식과 의료진의 업무 프로세스에 맞춰 커스터마이징이 가능합니다.
              </div>
            ) : (
              <div className={style.ability_txt}>
                병원의 기존 시스템 및 다양한 IT 인프라와 연동이 가능하며, 협진
                방식과 의료진의 업무 프로세스에 맞춰 커스터마이징이 가능합니다.
              </div>
            )}
          </div>
          {/* 3 */}
          <div className={style.ability_content}>
            <div className={style.ability_header}>
              <div className={style.ability_content_title}>
                <div className={style.title_en}>Scalability</div>
                <div className={style.title_kr}>확장성</div>
              </div>
              <div className={style.ability_outer_logo}>
                <div className={style.ability_inner_logo}>
                  <img
                    className={style.ability_logo_3}
                    alt="custom_ability_3"
                    src={`${process.env.REACT_APP_CLIENT_URL}img/solution/custom/customAbilityIcon3${!isMobile && !isTablet ? "" : "_m"}.png`}
                  />
                </div>
              </div>
            </div>
            {!isMobile && !isTablet ? (
              <div className={style.ability_txt}>
                소규모 병원부터 대형 병원까지, 병원의 규모와 요구사항에 따라
                확장
                <br />
                가능한 구조를 갖추고 있어 점진적인 기능 추가 및 연동이
                가능합니다.
              </div>
            ) : (
              <div className={style.ability_txt}>
                소규모 병원부터 대형 병원까지, 병원의 규모와 요구사항에 따라
                확장 가능한 구조를 갖추고 있어 점진적인 기능 추가 및 연동이
                가능합니다.
              </div>
            )}
          </div>
          {/* 4 */}
          <div className={style.ability_content}>
            <div className={style.ability_header}>
              <div className={style.ability_content_title}>
                <div className={style.title_en}>Convenience</div>
                <div className={style.title_kr}>편리성</div>
              </div>
              <div className={style.ability_outer_logo}>
                <div className={style.ability_inner_logo}>
                  <img
                    className={style.ability_logo_4}
                    alt="custom_ability_4"
                    src={`${process.env.REACT_APP_CLIENT_URL}img/solution/custom/customAbilityIcon4${!isMobile && !isTablet ? "" : "_m"}.png`}
                  />
                </div>
              </div>
            </div>
            {!isMobile && !isTablet ? (
              <div className={style.ability_txt}>
                의료진은 한 화면에서 협진 관련 모든 기능을 간편하게 사용할 수
                <br />
                있으며, 모바일과 태블릿에서도 원활하게 협진을 진행할 수
                있습니다.
              </div>
            ) : (
              <div className={style.ability_txt}>
                의료진은 한 화면에서 협진 관련 모든 기능을 간편하게 사용할 수
                있으며, 모바일과 태블릿에서도 원활하게 협진을 진행할 수
                있습니다.
              </div>
            )}
          </div>
          {/* 5 */}
          <div className={style.ability_content}>
            <div className={style.ability_header}>
              <div className={style.ability_content_title}>
                <div className={style.title_en}>Efficiency</div>
                <div className={style.title_kr}>효율성</div>
              </div>
              <div className={style.ability_outer_logo}>
                <div className={style.ability_inner_logo}>
                  <img
                    className={style.ability_logo_5}
                    alt="custom_ability_5"
                    src={`${process.env.REACT_APP_CLIENT_URL}img/solution/custom/customAbilityIcon5${!isMobile && !isTablet ? "" : "_m"}.png`}
                  />
                </div>
              </div>
            </div>
            {!isMobile && !isTablet ? (
              <div className={style.ability_txt}>
                병원 내 협진 절차를 간소화하고, 실시간 데이터 공유 및 원격
                협업을
                <br />
                지원하여 의료진의 업무 부담을 줄이고 환자 치료 속도를 향상
                <br />
                시킵니다.
              </div>
            ) : (
              <div className={style.ability_txt}>
                병원 내 협진 절차를 간소화하고, 실시간 데이터 공유 및 원격
                협업을 지원하여 의료진의 업무 부담을 줄이고 환자 치료 속도를
                향상 시킵니다.
              </div>
            )}
          </div>
        </div>
      </div>

      <div
        className={`${style.highlight_wrap} ${style.custom}`}
        style={{
          backgroundImage: `url('${process.env.REACT_APP_CLIENT_URL}img/solution/custom/customHighlightBg${isMobile ? "_m" : ""}.png')`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div
          className={`${style.highlight_inner_wrap_custom}`}
          style={{
            backgroundImage: `url('${process.env.REACT_APP_CLIENT_URL}img/solution/custom/customHighlightInnerBg${isMobile ? "_m" : ""}.png')`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          {isMobile ? (
            <>
              병원의 협진이 더 빠르고
              <br />
              안전하게 이루어질 수 있도록,
              <br />
              맞춤형 텔레헬스 협진 플랫폼으로
              <br />
              혁신적인 의료 환경을
              <br />
              구축해보세요.
            </>
          ) : (
            <>
              병원의 협진이 더 빠르고 안전하게 이루어질 수 있도록,
              <br />
              맞춤형 텔레헬스 협진 플랫폼으로 혁신적인 의료 환경을 구축해보세요.
            </>
          )}
        </div>
      </div>

      {props.type === "popup" ? (
        <div style={{ marginBottom: "70px" }}>
          <Consult />
        </div>
      ) : (
        <div className={style.device_consult_wrapper}>
          <Questions />
        </div>
      )}
    </>
  );
}

export default CustomPlatform;
